import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useToken = () => {
  const [params] = useSearchParams();

  return params.get('token') || '';
};

export const useOnEsignCompleted = (onCompleted: () => void) => {
  const handler = (e: MessageEvent<any>) => {
    const type = e.data?.type;

    if (type === 'session_view.document.completed') onCompleted();
  };

  useEffect(() => {
    window.addEventListener('message', handler);

    return () => window.removeEventListener('message', handler);
  });
};
